import { lazy, Suspense } from "react";
import type { UserPlatformCharts } from "@/lib/user-analytics";

function ChartGridSkeleton() {
  return (
    <div className="grid gap-4 lg:grid-cols-3">
      {Array.from({ length: 3 }).map((_, index) => (
        <div key={index} className="rounded-3xl bg-canvas p-4 sm:p-5">
          <div className="h-3 w-28 skeleton-shimmer rounded-full" />
          <div className="mt-2 h-3 w-44 skeleton-shimmer rounded-full" />
          <div className="mt-4 h-[220px] rounded-2xl bg-canvas-hover" />
        </div>
      ))}
    </div>
  );
}

const UserCharts = lazy(() => import("./UserCharts").then((mod) => ({ default: mod.UserCharts })));

export function LazyUserCharts({ charts }: { charts: UserPlatformCharts }) {
  return (
    <Suspense fallback={<ChartGridSkeleton />}>
      <UserCharts charts={charts} />
    </Suspense>
  );
}
